const ThirdPartyPhoneResourceStatistics = () =>
  import('@/views/main/thirdPartyPhoneAccountConfig/resourceStatistics/ThirdPartyPhoneResourceStatistics.vue')

export default {
  path: '/main/thirdPartyPhoneAccountConfig/resourceStatistics',
  name: 'ThirdPartyPhoneResourceStatistics',
  component: ThirdPartyPhoneResourceStatistics
}
